module.exports = {
  en: {},
};
